export default __webpack_public_path__ + "static/media/8900-tokenjuggler.e25cfded.pdf";